import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { SEND_SMS } from '../actions';

export const sendSMSEpic = (action$, store, { api }) =>
    action$.ofType(SEND_SMS).mergeMap(action =>
        Observable.from(api.sendSMS(action.payload))
            .map(response => actions.sendSMSSuccess(response.data))
            .catch(error => Observable.of(actions.sendSMSFailure(error))),
    );
